import type { ISerialize } from '@/objects/ISerialize';
import type { ExitStatus } from './../enums/ExitStatus';
import { formatDateIso } from '@/utilities/dateutils';

export class SetRaceContestantExitStatusRequest implements ISerialize {
    public ExitStatus: ExitStatus;

    public FlagTime: Date | null;

    public RaceContestantIds: number[];

    public Reason: string | null;

    /***
     * @deprecated Use the static FromJsValues method instead of the constructor to get type safety and default values
     */
    public constructor(values: { ExitStatus?: ExitStatus; FlagTime?: Date | null; RaceContestantIds?: number[]; Reason?: string | null }) {
        this.ExitStatus = values.ExitStatus ?? 'Finished';

        this.FlagTime = values.FlagTime ?? null;

        this.RaceContestantIds = values.RaceContestantIds ?? [];

        this.Reason = values.Reason ?? null;
    }

    public serialize(): string {
        return (
            '{' +
            `"ExitStatus": ${this.ExitStatus == 'Finished' ? 10 : this.ExitStatus == 'REL' ? 20 : this.ExitStatus == 'DNC' ? 30 : this.ExitStatus == 'DNF' ? 40 : this.ExitStatus == 'DSQ' ? 50 : this.ExitStatus == 'DNS' ? 60 : this.ExitStatus == 'DNQ' ? 70 : this.ExitStatus == 'LAP' ? 80 : this.ExitStatus == 'None' ? -99 : 10}` +
            ',' +
            `"FlagTime": ${this.FlagTime ? '"' + formatDateIso(this.FlagTime) + '"' : null}` +
            ',' +
            `"RaceContestantIds": [ ${this.RaceContestantIds.map((x) => JSON.stringify(x))} ]` +
            ',' +
            `"Reason": ${JSON.stringify(this.Reason)}` +
            '}'
        );
    }

    /**
     * Creates an instance of SetRaceContestantExitStatusRequest from the supplied values.
     * Missing values have default values
     * @param values The values you want to set
     * @returns An object instance with the supplied values set
     */
    public static FromJsValues(values: {
        ExitStatus?: ExitStatus;
        FlagTime?: Date | null;
        RaceContestantIds?: number[];
        Reason?: string | null;
    }): SetRaceContestantExitStatusRequest {
        return new SetRaceContestantExitStatusRequest(values);
    }

    public static _FromServerJson(json: any): SetRaceContestantExitStatusRequest {
        return new SetRaceContestantExitStatusRequest({
            ExitStatus:
                json.ExitStatus == 10
                    ? 'Finished'
                    : json.ExitStatus == 20
                      ? 'REL'
                      : json.ExitStatus == 30
                        ? 'DNC'
                        : json.ExitStatus == 40
                          ? 'DNF'
                          : json.ExitStatus == 50
                            ? 'DSQ'
                            : json.ExitStatus == 60
                              ? 'DNS'
                              : json.ExitStatus == 70
                                ? 'DNQ'
                                : json.ExitStatus == 80
                                  ? 'LAP'
                                  : json.ExitStatus == -99
                                    ? 'None'
                                    : 'Finished',
            FlagTime: json.FlagTime ? (json.FlagTime instanceof Date ? json.FlagTime : new Date(json.FlagTime)) : null,
            RaceContestantIds: json.RaceContestantIds,
            Reason: json.Reason ?? '',
        });
    }

    /**
     * Creates an instance of SetRaceContestantExitStatusRequest from another instance of SetRaceContestantExitStatusRequest.
     * @param other The SetRaceContestantExitStatusRequest you want to clone
     * @returns A cloned SetRaceContestantExitStatusRequest
     */
    public static FromOther(other: SetRaceContestantExitStatusRequest): SetRaceContestantExitStatusRequest {
        return SetRaceContestantExitStatusRequest._FromServerJson(JSON.parse(other.serialize()));
    }

    /**
     * Deepclones the object.
     */
    public DeepClone() {
        return SetRaceContestantExitStatusRequest.FromOther(this);
    }

    static NAME_OF_CLASS = 'SetRaceContestantExitStatusRequest';
}
